import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classnames from 'classnames';
import { createEntity } from './CreateEntityModalAPI';

import './CreateEntityModal.css';

import EntityValueInput from '../CreateEntityModal/EntityValueInput';
import EntityTag from '../CreateEntityModal/EntityTag';

class CreateEntityModal extends Component {

  static defaultProps = {
    createEntity : () => {
      console.error("CreateEntityModal.props.createEntity is undefined");
    }
  }

  state = {
    entityName : "",
    entityValueArray : [],
  }

  handleEntityValueInputConfirmed = (entityValue) => {

    if (entityValue.trim() === "" ) {
      alert("값을 입력해주세요");
      return;
    }

    const updatedArray = this.state.entityValueArray.concat(entityValue);

    this.setState({
      entityValueArray : updatedArray,
    })
  }

  handleEntityNameOnChanged = (e) => {
    const { value } = e.target;
  
    this.setState({
      entityName : value,
    })
  }

  handleConfirmBtnOnClicked = (e) => {
    const { entityName } = this.state;
    const { entityValueArray } = this.state;
    const { topicUpdateID } = this.props;
    createEntity(this.callBackCreateEntity, topicUpdateID, entityName, entityValueArray);
  }
  callBackCreateEntity = (response) => {
    
    const {data} = response;
    const {statusCode} = data;

    switch(statusCode) {
      case 200:
      const { initializeState } = this;
      const { toggleCreateEntityModal } = this.props;
      // To store
      const createEntity_ = this.props.createEntity;
      const {property} = data;

      const {updateID} = property;
      const {createdObject} = property;
      const {entityName} = createdObject;
      let {entityValue} = createdObject;
      // Not exist entity value
      if (entityValue.trim() === "") {
        entityValue = [];
      } else {
        entityValue = entityValue.split("|");
      }
      createEntity_(entityName, entityValue, updateID);
      toggleCreateEntityModal();
      initializeState();
      break;
      
      case 403:
      const { subCode } = data;
      switch(subCode) {
        case 1:
        alert("중복된 엔티티명 입니다.");
        break;
        default:
        alert("에러가 발생하였습니다. subCode : " + subCode);
      }
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다");
      break;

      default:
      alert("에러가 발생하였습니다.");
    }
  }

  renderEntityValueTags = (entityValueArray) => {
    const rendered = entityValueArray.map( (entity, i) => {
      return (
        <EntityTag 
          key={i}
          entityValue={entity} />
      );
    });
    return rendered;
  }

  // initialize state this component
  initializeState = () => {
    this.setState({
      entityName : "",
      entityValueArray : [],
    })
  }

  render() { 

    const { handleEntityValueInputConfirmed } = this;
    const { renderEntityValueTags } = this;
    const { handleConfirmBtnOnClicked } = this;
    const { handleEntityNameOnChanged } = this;

    const { isCreateEntity } = this.props;
    const { toggleCreateEntityModal } = this.props;

    const {entityValueArray} = this.state;
    const {entityName} = this.state;

    const modalClassNames = classnames({
      "create-entity-modal" : true,
      "show" : isCreateEntity,
      "hide" : !isCreateEntity,
    })

    const whiteSpace_classNames = classnames({
      "white-space" : true,
      "second-modal-white-space" : true,
      "show" : (isCreateEntity),
      "hide" : (!isCreateEntity),
    })

    const renderedEntityValueTags = renderEntityValueTags(entityValueArray);

    return (
      // <CSSTransitionGroup transitionName="entityModal" transitionEnterTimeout={250} transitionLeaveTimeout={250} >
      <React.Fragment>
        <div className={whiteSpace_classNames} onClick={(e) => {e.stopPropagation(); toggleCreateEntityModal();}}>
        </div>
        <div className={modalClassNames}>
          <div className="create-entity-header">
            <input className="entity-name-input" placeholder="엔티티 이름"
              value={entityName}
              onChange={handleEntityNameOnChanged} />
          </div>
          <div className="create-entity-body">
            <div className="entity-value-stack">
              {renderedEntityValueTags}
              <EntityValueInput 
                bringValueToParents={handleEntityValueInputConfirmed}
                // initializeState={} 
              />
            </div>
          </div>
          <div className="create-entity-bottom">
            <button className="create-entity-confirm-btn"
              onClick={handleConfirmBtnOnClicked} >
              생성
            </button>
          </div>
        </div>
      </React.Fragment>
      // {/* </CSSTransitionGroup> */}
    );
  }
}
 
export default CreateEntityModal;